module.exports = __webpack_public_path__ + "staticcomp/img/top.d1933cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/1/top.jpg
// module id = 6OyP
// module chunks = 39